
import type { Supplier } from "@/models/supplier";
import { addSupplier, deleteSupplier } from "@/services/supplierService";
import { getSuppliers } from "@/services/suppliersService";
import { defineStore } from "pinia";

export interface ISuppliers {
    suppliers: Supplier[];
    loading: boolean;
}

export const useSuppliersStore = defineStore("suppliers", {
    state: (): ISuppliers => ({
        suppliers: [],
        loading: false
    }),

    getters: {
        hasSuppliers: (state) => state.suppliers.length > 0,
    },

    actions: {
        async setSupplierList(): Promise<void> {
            this.loading = true;
            try {
                this.suppliers = await getSuppliers();
            } catch (error) {
                throw new Error("Could not get supplier list");
            } finally {
                this.loading = false;
            }
        },

        async addSupplierToList(supplier: Supplier) {
            this.loading = true;
            try{
                await addSupplier(supplier);
                await this.setSupplierList();
            } catch (error) {
                throw new Error("Could not add supplier");
            } finally {
                this.loading = false;
            }
        },

        async removeSupplierFromList(supplier: Supplier) {
            this.loading = true;
            try{
                await deleteSupplier(supplier);
                await this.setSupplierList();
            } catch (error) {
                throw new Error("Could not remove supplier");
            } finally {
                this.loading = false;
            }
        }
    }
})